import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const BacktoTop = () => {
  const { t } = useTranslation()
  return (
    <Box
      onClick={() => window.scrollTo(0, 0)}
      textAlign="center"
      marginTop="66px"
      marginBottom="40px">
      <Typography color={'baseColor.colorText1'} component="h4" fontWeight="500" fontSize="1.6rem">
        {t('actions.back_to_top')}
      </Typography>
    </Box>
  )
}

export default React.memo(BacktoTop)
